import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "kmt-storefinder__locationfilter__list" }
const _hoisted_2 = {
  key: 0,
  class: "kmt-radioinputlist"
}
const _hoisted_3 = ["value"]
const _hoisted_4 = {
  key: 1,
  class: "kmt-radioinputlist"
}
const _hoisted_5 = ["value"]
const _hoisted_6 = {
  key: 2,
  class: "kmt-radioinputlist"
}
const _hoisted_7 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["kmt-storefinder__locationfilter", _ctx.isOpenedCSSClass])
  }, [
    _createElementVNode("div", {
      class: "kmt-storefinder__locationfilter__handler",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggle()))
    }),
    _createElementVNode("div", _hoisted_1, [
      (_ctx.configuration.filterDistances.length > 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.translationComposition.distanceHeadline), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.configuration.filterDistances, (distance) => {
              return (_openBlock(), _createElementBlock("label", {
                class: "kmt-radioinput",
                key: distance.key
              }, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  name: "distance",
                  value: distance.key,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.distanceRef) = $event)),
                  onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.change && _ctx.change(...args)))
                }, null, 40, _hoisted_3), [
                  [_vModelRadio, _ctx.distanceRef]
                ]),
                _createElementVNode("span", null, _toDisplayString(distance.label), 1)
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (_ctx.configuration.filterRegions.length > 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.translationComposition.regionHeadline), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.configuration.filterRegions, (region) => {
              return (_openBlock(), _createElementBlock("label", {
                class: "kmt-radioinput",
                key: region.key
              }, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  name: "region",
                  value: region.key,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.regionRef) = $event)),
                  onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.change && _ctx.change(...args)))
                }, null, 40, _hoisted_5), [
                  [_vModelRadio, _ctx.regionRef]
                ]),
                _createElementVNode("span", null, _toDisplayString(region.label), 1)
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (_ctx.configuration.filterTypes.length > 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("h3", null, _toDisplayString(_ctx.translationComposition.typeHeadline), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.configuration.filterTypes, (type) => {
              return (_openBlock(), _createElementBlock("label", {
                class: "kmt-radioinput",
                key: type.key
              }, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  name: "type",
                  value: type.key,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.typeRef) = $event)),
                  onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.change && _ctx.change(...args)))
                }, null, 40, _hoisted_7), [
                  [_vModelRadio, _ctx.typeRef]
                ]),
                _createElementVNode("span", null, _toDisplayString(type.label), 1)
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("small", {
        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.reset()))
      }, _toDisplayString(_ctx.translationComposition.resetTranslation), 1)
    ])
  ], 2))
}